import React, { useMemo, useState } from "react";
import ReportRow from "./ReportRow";
import { FREQUENCIA, TIPO_EXCEL } from "./enums";
import { buildInitialConfigState, buildPayload, normalizeOnToggle } from "./utils";

export default function ReportConfigList({
  reportItems,
  initialConfig = [],
  onChange,
  showPayloadPreview = true,
  renderItemContent,
}) {
  const [configState, setConfigState] = useState(() =>
    buildInitialConfigState(reportItems, initialConfig)
  );

  React.useEffect(() => {
    setConfigState(buildInitialConfigState(reportItems, initialConfig));
  }, [reportItems, initialConfig]);

  const payload = useMemo(() => buildPayload(configState), [configState]);

  const applyNext = (nextState) => {
    setConfigState(nextState);
    if (onChange) {
      onChange(nextState, buildPayload(nextState));
    }
  };

  const onToggle = (id, checked, tipo) => {
    const current = configState[id] || { id, ativo: false };

    applyNext({
      ...configState,
      [id]: normalizeOnToggle(current, checked, tipo),
    });
  };

  const onFrequenciaChange = (id, frequencia) => {
    const current = configState[id];
    if (!current) return;

    applyNext({
      ...configState,
      [id]: {
        ...current,
        frequencia,
      },
    });
  };

  const onTipoExcelChange = (id, tipoExcel) => {
    const current = configState[id];
    if (!current) return;

    applyNext({
      ...configState,
      [id]: {
        ...current,
        tipoExcel,
      },
    });
  };

  const groupedReportItems = useMemo(() => {
    return [
      reportItems.slice(0, 3),
      reportItems.slice(3, 5),
      reportItems.slice(5, 7),
    ].filter((group) => group.length > 0);
  }, [reportItems]);

  return (
    <div style={{ width: "100%" }}>
      {groupedReportItems.map((group, index) => (
        <div
          key={`report-group-${index}`}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 8,
            paddingBottom: 12,
            marginBottom: 12,
            borderBottom: "1px solid var(--theme-border-color, #e9ecef)",
          }}
        >
          {group.map((item) => {
            const currentConfig = configState[item.id] || { id: item.id, ativo: false };

            return (
              <React.Fragment key={item.id}>
                <ReportRow
                  item={item}
                  config={currentConfig}
                  onToggle={onToggle}
                  onFrequenciaChange={onFrequenciaChange}
                  onTipoExcelChange={onTipoExcelChange}
                />
                {renderItemContent ? renderItemContent(item, currentConfig) : null}
              </React.Fragment>
            );
          })}
        </div>
      ))}

      {showPayloadPreview && (
        <div style={{ marginTop: 14 }}>
          <strong>Payload:</strong>
          <pre
            style={{
              background: "var(--bg-card)",
              borderRadius: 8,
              padding: 12,
              marginTop: 8,
              overflowX: "auto",
            }}
          >
            {JSON.stringify(payload, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}

export { FREQUENCIA, TIPO_EXCEL, buildPayload };
